import React from 'react';
import { Cushion, MaxWidth, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import SeoHead from '../seo';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import NoBackground from '../club-frame/header/no-background';
import { Trans } from '../../lib/i18n';
import BookingWidget from './booking-widget';

const BookingsPage = ({ club, workspaceName, widgetId, widgetDomain }) => (
  <>
    <SeoHead
      club={club}
      titleTranslationKey="common:bookings_title"
      descriptionTranslationKey="common:bookings_description"
      route="bookings"
    />

    <NoBackground />
    <Shadow>
      <Rectangle fill="white" borderTop="thinLightGrey" component="div">
        <Cushion
          responsive={[{ maxWidth: 'tab', props: { horizontal: 'medium' } }]}
          horizontal="large"
          vertical="medium"
          component="div"
        >
          <MaxWidth component="div" maxWidth={1366} center>
            <Typography
              preset="title"
              component="div"
              responsive={[{ maxWidth: 'tab', props: { align: 'center' } }]}
            >
              <Trans i18nKey="common:bookings_title">Facility Bookings</Trans>
            </Typography>
          </MaxWidth>
        </Cushion>
      </Rectangle>
    </Shadow>

    <Cushion
      horizontal="large"
      vertical="medium"
      responsive={[{ maxWidth: 'tab', props: { horizontal: 'small' } }]}
      component="div"
    >
      <Shadow>
        <MaxWidth component="div" maxWidth={1360} center>
          <Rectangle fill="white" radius="rounded" style={{ minHeight: '300px' }}>
            <Cushion all="medium" responsive={[{ maxWidth: 'tab', props: { all: 'small' } }]}>
              <BookingWidget
                workspaceName={workspaceName}
                widgetId={widgetId}
                widgetDomain={widgetDomain}
              />
            </Cushion>
          </Rectangle>
        </MaxWidth>
      </Shadow>
    </Cushion>
  </>
);

BookingsPage.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  workspaceName: PropTypes.string.isRequired,
  widgetId: PropTypes.string.isRequired,
  widgetDomain: PropTypes.string.isRequired,
};

export default BookingsPage;
